module.exports = __webpack_public_path__ + "static/media/meetingtable.48e2d709.png";